import Vue from 'vue'
import Vuex from 'vuex'

import projects from './store/projects';
import themas from './store/themas';
import partijen from './store/partijen';

import generatedData from './data.json';

Vue.use(Vuex)

export default new Vuex.Store({
  modules: [
    projects,
    themas,
    partijen
  ],
  state: {
    extended: false,
    sidepanel: 'GlobalGoals',
    data: generatedData
  },
  mutations: {
    extended_set(state, { extended }) {
      state.extended = !! extended;
    },
    sidepanel_set(state, { panel }) {
      state.sidepanel = panel;
    },
    setDataset(state, { dataset }) {
      state.data = dataset
    }
  },
  actions: {
    extended_set(context, { extended }) {
      context.commit('extended_set', { extended });
    },
    sidepanel_set(context, { panel }) {
      context.commit('sidepanel_set', { panel });
    },
  }
}) 
 